import { render, staticRenderFns } from "./DropItem.vue?vue&type=template&id=5627b42d&scoped=true&"
import script from "./DropItem.vue?vue&type=script&lang=js&"
export * from "./DropItem.vue?vue&type=script&lang=js&"
import style0 from "./DropItem.vue?vue&type=style&index=0&id=5627b42d&prod&lang=scss&scoped=true&"
import style1 from "./DropItem.vue?vue&type=style&index=1&id=5627b42d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5627b42d",
  null
  
)

export default component.exports